import { render, staticRenderFns } from "./SettingsPage.vue?vue&type=template&id=642ebe6c&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"
import style0 from "./SettingsPage.vue?vue&type=style&index=0&id=642ebe6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ebe6c",
  null
  
)

export default component.exports